export default {
  LOGIN_GET_ACCESS: 'Få tilgang',
}
